import { render, staticRenderFns } from "./BannerImagem.vue?vue&type=template&id=a61ea872&scoped=true&lang=pug"
import script from "./BannerImagem.vue?vue&type=script&lang=js"
export * from "./BannerImagem.vue?vue&type=script&lang=js"
import style0 from "./BannerImagem.styl?vue&type=style&index=0&id=a61ea872&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61ea872",
  null
  
)

export default component.exports